import React from "react";
import { Link } from "react-router-dom";
import {
  Mail,
  Phone,
  MapPin,
  Facebook,
  Instagram,
} from "lucide-react";
import "./Footer.css";

const Footer = () => {
  return (
    <footer className="footer">
      <div className="container footer-container">
        <div className="footer-col brand-col">
          <div className="footer-logo">
            <img
              src="/sotaklogo.png"
              alt="SOTAK Logo"
              className="logo-image-footer"
            />
          </div>
          <p className="footer-desc">
            Leading the way in real estate development, property management, and
            strategic investments. Building your future today.
          </p>
          <div className="social-links">
            <a
              href="https://web.facebook.com/profile.php?id=61585673610209"
              className="social-link"
              target="_blank"
              rel="noopener noreferrer"
            >
              <Facebook size={20} />
            </a>
            <a
              href="https://www.instagram.com/sotakinvestproperty?igsh=MWFwdTh0bmtpd21kbA=="
              className="social-link"
              target="_blank"
              rel="noopener noreferrer"
            >
              <Instagram size={20} />
            </a>

          </div>
        </div>

        <div className="footer-col links-col">
          <h3>Quick Links</h3>
          <ul>
            <li>
              <Link to="/">Home</Link>
            </li>
            <li>
              <Link to="/about">About Us</Link>
            </li>
            <li>
              <Link to="/services">Services</Link>
            </li>
            <li>
              <Link to="/projects">Projects</Link>
            </li>
            <li>
              <Link to="/contact">Contact</Link>
            </li>
          </ul>
        </div>

        <div className="footer-col contact-col">
          <h3>Contact Us</h3>
          <ul className="contact-list">
            <li>
              <MapPin size={18} className="contact-icon" />
              <span>11 Seychelles street EFAB Metropolis Karsana Abuja</span>
            </li>
            <li>
              <Phone size={18} className="contact-icon" />
              <span>08023046244 | 08070708844</span>
            </li>
            <li>
              <Mail size={18} className="contact-icon" />
              <span>sotakinvest@gmail.com</span>
            </li>
          </ul>
        </div>
      </div>
      <div className="footer-bottom">
        <p>
          &copy; {new Date().getFullYear()} Sotak Investment and Property
          Company Ltd. All rights reserved.
        </p>
      </div>
    </footer>
  );
};

export default Footer;
